module.exports = __webpack_public_path__ + "img/map_1.80a04698.png";